import { LocalStorage } from './local.storage';

export default new LocalStorage();
